<script>

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import simplebar from "simplebar-vue";
/**
 * team-list component
 */

export default {
  page: {
    title: "Remote Access",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, simplebar },
  data() {
    return {
      loginData: {},
      companyId: null,
      title: "Remote Access",
      filterValue: "",
      showModal: false,
    };
  },
  methods: {
    openModal() {
      this.showModal = true;
    },
    nameWithLang({ text }) {
      return `${text}`;
    },
  },
  created() {
    this.loginData = JSON.parse(localStorage.getItem('user'));
  },
  computed: {
    searchevents: function() {
      var result = this.teams;
      if (!this.filterValue)
        return result;
      
      const filterValue = this.filterValue.toLowerCase();

      const filter = event => 
          event.teamName.toLowerCase().includes(filterValue);
      
      return result.filter(filter);
    },
  },
  
};
</script>

<template>
  <Layout>
    <PageHeader :title="'Remote Access'" />
    <div class="row">
      <div class="search-box  col-sm-4 mb-2">
        <div class="position-relative">
          <input
            type="text"
            class="form-control"
            :placeholder="$t('menuitems.teams.search')"
            v-model="filterValue"
          />
          <i class="bx bx-search-alt search-icon"></i>
        </div>
      </div>
      <div class="col-sm-8 mb-2">
        <div class="text-sm-end">
          <button class="btn btn-secondary mb-2 me-2">
            <i class="bx bx-download me-1"></i> Download
          </button>
        </div>
      </div>
    </div>
    
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="is-loading">
                <div class="preloader-component" v-show="false">
                  <div class="status">
                    <div class="spinner-chase">
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                    </div>
                  </div>
                </div>
            <div class="card-body" style="height: calc(100vh - 274px);">
              <simplebar ref="current" style="max-height: calc(100vh - 300px);">
                
                <div class="table-responsive">
                  <table class="table align-middle table-nowrap table-hover">
                    <thead class="table-light">
                      <tr>
                        <th scope="col">Details</th>
                        <th scope="col">Computer Name</th>
                        <th scope="col">Last Access Type</th>
                        <th scope="col">Last Access Details</th>
                        <th scope="col">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Abhilash Aman<br/>
                                <span class="text-secondary">abhilash@workrhythm.net</span><br/>
                                <span class="text-secondary">Software Engineer</span></td>
                            <td>Abhilash's-MAC</td>
                            <td><span class="badge badge-soft-warning font-size-13" role="button">Remote Access</span></td>
                            <td>12 Dec 2020 (13 : 00 - 13 : 12)</td>
                            <td><button class="btn btn-link fw-bold" style="color: #556ee6;" disabled>Not Live</button></td>
                        </tr>
                        <tr>
                            <td>Abhilash Aman<br/>
                                <span class="text-secondary">abhilash@workrhythm.net</span><br/>
                                <span class="text-secondary">Software Engineer</span></td>
                            <td>Abhilash's-MAC</td>
                            <td><span class="badge badge-soft-info font-size-13" role="button">Only Live Streaming</span></td>
                            <td>12 Dec 2020 (13 : 00 - 13 : 12)</td>
                            <td><button @click="openModal" class="btn btn-link fw-bold" style="color: #61b045;">Get Access <i class="bx bx-video fs-6"></i></button></td>
                        </tr>
                    </tbody>
                  </table>
                </div>
            
              </simplebar>

            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal v-model="showModal"  size="xl" :title="'Live Screen Streaming'" hide-footer>
      <div style="height: calc(100vh - 143px);width: calc(100% - 00px);">
      <div class="parent">
        <!--<img class="image1" style="height: calc(100vh - 143px);width: calc(100% - 2rem);" src="@/assets/images/mac-mockup.png" />-->
        <img class="image2"  style="height: calc(100vh - 143px);width: calc(100% - 0px);" src="@/assets/images/loading.gif" />
      </div>
    </div>
    </b-modal>
  </Layout>
</template>
<style scoped>
.is-loading {
  position: relative;
}
.preloader-component {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  width: 100%;
  background-color: #fff;
}
.status {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -20px 0 0 -20px;
}
.parent {
  position: relative;
  top: 0;
  left: 0;
}
.image1 {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 1;
}
.image2 {
  position: absolute;
  z-index: 2;
  border: 29px solid #000000;
  border-radius: 24px;
}
@media (min-height: 768px) {
  .img-card-height {
    height: 540px;
  }
}
@media (min-height: 769px) {
  .img-card-height {
    height: calc(100vh - 143px - 275px);
  }
}
@media only screen and (min-width: 1200px) {
.img-card {
    width: calc(100% - 90px);
      top: 36px;
      left: 39px;
}
}
@media only screen and (max-width: 1200px) {
.img-card {
    width: calc(100% - 70px);
    top: 36px;
    left: 29px;
}
}
@media only screen and (max-width: 991px) {
.img-card {
    width: calc(100% - 54px);
    top: 36px;
    left: 21px;
}
}
</style>